import { useEffect, useState } from "react";
import { Box, Paper, Stack, TextField, Typography } from "@mui/material";
import { isRichTextContentEmpty } from "../../../../../utils/rich-text-empty";
import { Item } from "../preview-model";
import { RenderRichText } from "../../../components/rich-text/render-rich-text";

interface SubHeaderViewProps {
    item: Item;
    setResource: React.Dispatch<React.SetStateAction<string>>;
}

export default function SubHeaderView({ item, setResource }: SubHeaderViewProps) {
    return (
        <Paper
            key={item.id}
            elevation={1}
            sx={{
                display: 'flex',
                flexDirection: 'column',
                p: 3,
                border: '1px solid #e0e0e0',
                borderRadius: 2,
                backgroundColor: '#fff',
                gap: 2
            }}
        >
            {(item.title || item.required || item.marks) && (
                <Box
                    sx={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                    }}
                >
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                        {!isRichTextContentEmpty(item.title) && (
                            <RenderRichText jsonContent={item.title} />
                        )}
                        {(item.type !== 0 && item.required) && (
                            <Typography color="error">*</Typography>
                        )}
                    </Box>

                        <Typography variant="caption" color="text.secondary">
                        {item.marks} mark{item.marks !== 1 ? 's' : ''}
                    </Typography>
                </Box>
            )}

            {!isRichTextContentEmpty(item.description) && (
                <Box>
                    <RenderRichText jsonContent={item.description} />
                </Box>
            )}
            
            {item.resources?.length > 0 && (
                <Stack
                    direction="row"
                    spacing={1}
                    sx={{ overflowX: "auto",}}
                >
                    {item.resources.map((res, i) => {
                        const handleResourceClick = () => {
                            setResource(res);
                        };

                        return (
                            <Box
                                key={i}
                                component="img"
                                src={res}
                                alt={`resource-${i}`}
                                onClick={handleResourceClick}
                                sx={{
                                    width: 48,
                                    height: 48,
                                    objectFit: 'cover',
                                    borderRadius: 1,
                                    cursor: 'pointer',
                                    border: '1px solid #ccc',
                                }}
                            />
                        );
                    })}
                </Stack>
            )}
        </Paper>
    )
}
